import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { getData, postFormData } from 'utils/service';
  // declaring the types for our state
  export type AdvertisementState = {
    advtData: any;
    pending: boolean;
  };
  
  const initialState: AdvertisementState = {
    advtData: [],
    pending: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getAdvertisementData = createAsyncThunk('api/advertisements', async () => {
    let data: any = { }
    let response: any = await getData('advertisements', data);
    if (response.success === "true") {
      return response
    }
    return {};
  });
  
  export const AdvertisementSlice = createSlice({
    name: 'advertisements',
    initialState,
    reducers: {
    },

    extraReducers: builder => {
      builder
        .addCase(getAdvertisementData.pending, state => {
          state.pending = true;
        })
        .addCase(getAdvertisementData.fulfilled, (state, { payload }) => {
          state.pending = false;
          state.advtData = payload.data;
        });
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
   
  } = AdvertisementSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectAdvertisements = (state: RootState) => state.advertisements;
  
  // exporting the reducer here, as we need to add this to the store
  export default AdvertisementSlice.reducer;